/**
 * arrayChunkInGroups([1, 2, 3, 4, 5], 2) => [[1, 2],[3, 4],[5]]
 * @param arr
 * @param groupSize
 */
export const arrayChunkInGroups = <Item>(
  arr: Item[],
  groupSize: number
): Item[][] => {
  const result: Item[][] = [];

  let pos = 0;

  while (pos < arr.length) {
    result.push(arr.slice(pos, pos + groupSize));
    pos += groupSize;
  }

  return result;
};
